import React from "react";
import { observable, action } from "mobx";
import { map, mapValues } from "lodash";
import { Typography } from "@material-ui/core";
import i18n from "locale/i18n";

export default class Error<T> {
  private namespace = "";

  @observable.ref
  public messages: React.ReactNode[] = [];

  @observable.ref
  public columns: { [P in keyof T]?: React.ReactNode[] } = {};

  public constructor(namespace?: string) {
    this.namespace = namespace || "";
  }

  @action.bound
  public set(error: any = {}) {
    this.messages = map(error.messages, (message: string) => (
      <Typography key={message} component="p" variant="caption" color="inherit">
        {i18n.exists(`${this.namespace}.${message}`)
          ? i18n.t(`${this.namespace}.${message}`)
          : i18n.t(`validation.${message}`)}
      </Typography>
    ));

    this.columns = mapValues(error.columns, (messages) =>
      messages.map((message: string) => (
        <Typography
          key={message}
          component="p"
          variant="caption"
          color="inherit"
        >
          {i18n.exists(`${this.namespace}.${message}`)
            ? i18n.t(`${this.namespace}.${message}`)
            : i18n.t(`validation.${message}`)}
        </Typography>
      ))
    );
  }

  public clear() {
    this.set({});
  }
}
